module.exports = __webpack_public_path__ + "img/ie_setting_02_Option2.74796904.jpg";